module.exports.BinarySearchTree = require('./lib/bst');
module.exports.AVLTree = require('./lib/avltree');



//////////////////
// WEBPACK FOOTER
// ./~/binary-search-tree/index.js
// module id = 738
// module chunks = 0